module.exports = __webpack_public_path__ + "img/6.5b5451a3.jpg";